export const liveOpsPathResources = {
    agents: "agents",
    tasks: "tasks",
    queues: "queues",
    recentActivity: "recent-activity",
} as const;
